var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header dtbanner"},[_c('div',{staticClass:"container dtcontainer"},[_c('a',{attrs:{"href":"https://dnssec-tools.org/","target":"https://dnssec-tools.org/"}},[_c('img',{staticClass:"logo",attrs:{"src":"https://dnssec-tools.org/images/dnssec-tools-Army-Knife.png","alt":"DNSSEC-Tools: is your domain secure?"}})])])])
}]

export { render, staticRenderFns }